<template>
	<custom-button class="secondary"><slot></slot></custom-button>
</template>

<script>
import CustomButton from "./CustomButton";

export default {
	props: {
		btnType: String,
	},
	components: {
		CustomButton,
	},
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/main.scss";

.secondary {
	font-weight: normal;
	background-color: $blue-lighter;
	$shadow-size: 3px;
	$shadow-color: transparentize($blue-lighter, 0.5);
	transition: 0.3s;
	box-shadow: 0px $shadow-size $shadow-color;
	&:hover {
		$offset: 2px;
		transform: translateY(-($offset));
		box-shadow: 0px ($shadow-size + $offset) $shadow-color;
		background-color: lighten($blue-lighter, 5%);
		transition: $trd-m;
	}
	&:active {
		background-color: darken($blue-lighter, 5%);
		box-shadow: 0px -2px $blue-darkest;
		transform: translateY(2px);
	}
	&:disabled {
		color: darken($blue-lightest, 10%);
		cursor: not-allowed;
		&:hover {
			background-color: $blue-lighter;
		}
	}
}
</style>
